import React from "react";

import AvatarUI from "../UI/AvatarUI";

// Avatarul vechi: acum e AvatarUI (poza sau inițialele, culoarea după nume), cu
// cercul dat de className-ul fiecărui loc (studentItem__avatar…). Locurile noi
// folosesc direct AvatarUI cu size.
export default function UserAvatar({
   person = null,
   color,
   initials,
   className = "studentItem__avatar",
   textClassName = "",
   style = {},
   alt = "",
}) {
   return (
      <AvatarUI
         person={person}
         color={color}
         initials={initials && initials !== "–" ? initials : undefined}
         size={null}
         className={className}
         textClassName={textClassName}
         style={style}
         alt={alt}
      />
   );
}
